<template>
  <div v-if="props.isSingleItem && props.option.colorCode">
    <div class="flex items-center pb-2">
      <div class="size-10 border border-border-medium p-px" :style="{ backgroundColor: props.option.colorCode }" :alt="props.option.name" :title="props.option.name" />
      <span v-if="props.option && props.option.isOptionAvailable === 0" class="ml-2 text-sm text-text-attention">
        {{ t['w.global.product_option.not_available']() }}
      </span>
      <span v-else-if="props.option && props.option.isOptionAvailable === null" class="ml-2 text-sm text-text-attention">
        {{ t['w.global.product_option.not_available_variation']() }}
      </span>
    </div>
  </div>
  <div v-else-if="props.option.colorCode" :class="{ 'border-b border-border pt-4': !props.hideTitle, 'pb-4': props.option.colorCode }">
    <div v-if="!props.hideTitle" class="mb-2 text-base">
      {{ t['w.global.selected_option']() }}
      <span class="text-left font-semibold">
        {{ props.option.name }}
        <span v-if="props.option.description"> - {{ props.option.description }}</span>
      </span>
    </div>
    <div class="flex items-center" :class="{ '-mt-2': props.hideTitle }">
      <div class="size-10 border border-border-medium p-px" :style="{ backgroundColor: props.option.colorCode }" :alt="props.option.name" :title="props.option.name" />
      <span v-if="props.option && props.option.isOptionAvailable === 0" class="ml-2 text-sm text-text-attention">
        {{ t['w.global.product_option.not_available']() }}
      </span>
      <span v-else-if="props.option && props.option.isOptionAvailable === null" class="ml-2 text-sm text-text-attention">
        {{ t['w.global.product_option.not_available_variation']() }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import * as t from '~/messages'

const props = defineProps({
  option: {
    type: Object,
    default: null,
  },
  hideTitle: {
    type: Boolean,
    default: false,
  },
  isSingleItem: {
    type: Boolean,
    default: null,
  },
})
</script>
